
import SlidebarDoctor from "@/components/SlidebarDoctor.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "doctor",
  components: {
    SlidebarDoctor,
  },
};
